module.exports = __webpack_public_path__ + "64add801766beff49a5c08137eb33bc0.pdf";